import React, { useEffect, useState } from "react";
import {
  Grid,
  Chip,
  Typography,
  Box,
  Stack,
  Button,
  Paper,
} from "@mui/material";

import CircleIcon from "@mui/icons-material/Circle";

import { useNavigate } from "react-router-dom";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";
import CandidateProfilePage from "../CandidateProfile/CandidateProfilePage";
import HorizontalStageBox from "./Components/HorizontalStageBox";

const CandidateDash = () => {
  const { candidateJobData, notifications } = useCandidateLayout();

  const Navigate = useNavigate();

  const jobTitle = candidateJobData[0]?.JD_Title;
  const jobId = candidateJobData[0]?.JD_JobId;
  
  // const stages = candidateJobData[8]?.recruitment_json
  //   ? JSON.parse(candidateJobData[8].recruitment_json)?.stages || []
  //   : [];

  const stages = candidateJobData[0]?.recruitment_details?.CandidateField?.stages

  return (
    <Paper
      sx={{
        padding: 2,
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
        maxWidth: "100vw",
        boxShadow: "none",
      }}
    >
      {/* Job Procedure Mapping */}
      <Grid container>
        {jobId && jobTitle && (
          <Grid
            item
            xs={12}
            sx={{

              margin: "10px auto",
              borderRadius: "10px",
              padding: "20px",
              border: candidateJobData[0]?.JA_Isdeployed
                ? "2px solid #2E7D32" // dark green
                : candidateJobData[0]?.JA_Cancellation
                  ? "2px solid #C62828" // dark red
                  : "1px solid #D0D0D0",
              backgroundColor: candidateJobData[0]?.JA_Isdeployed
                ? "#E8F5E9" // light green tint
                : candidateJobData[0]?.JA_Cancellation
                  ? "#FDECEA" // light red tint
                  : "#FAFAFA",
              color: "#1F2937", // neutral dark text
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                alignItems: "center",
                marginBottom: "20px",
                gap: 1, // optional spacing between wrapped items

              }}
            >
              {/* Application Progress - Job Title */}
              <Typography
                sx={{
                  px: 2,
                  textAlign: "left",
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "22px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                {`(${jobId}) - ${jobTitle}`}{" "}

                {candidateJobData[0]?.JA_Cancellation ? (
                  <Chip
                    label="Cancelled"
                    size="small"
                    sx={{
                      bgcolor: "#FDECEA",
                      fontSize: "18px",
                      color: "#B42318",
                      border: "1px solid #C62828",
                    }}
                  />
                ) : candidateJobData[0]?.JA_Isdeployed ? (
                  <Chip
                    label="Deployed"
                    size="small"
                    sx={{
                      bgcolor: "#E8F5E9",
                      fontSize: "18px",
                      color: "#1B5E20",
                      border: "1px solid #2E7D32",
                    }}
                  />
                ) : null}

                {candidateJobData[0]?.JA_CancellationRemarks ? (
                  <Box
                    sx={{
                      mt: 2,
                      px: 2,
                      py: 1.2,
                      borderRadius: "8px",
                      backgroundColor: "#FFF5F5",
                      border: "1px solid #F5C2C7",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#B42318",
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      Cancellation Reason:
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#7A271A",
                        mt: 0.5,
                      }}
                    >
                      {candidateJobData[0].JA_CancellationRemarks}
                    </Typography>
                  </Box>
                ) : null}
              </Typography>

              <Button
                variant="text"
                onClick={() => Navigate(`/Jobs`)}
                sx={{
                  minWidth: "100px",
                  color: "white",
                  background: "#006CB8",
                  mt: 0.5,
                  height: "30px",
                  textTransform: "capitalize",
                  ml: "auto", // pushes right when wrapped
                }}
              >
                View All
              </Button>
            </Box>

            {/* Horizontal Scrollable Box of Stages */}
            {!candidateJobData[0]?.JA_Cancellation ? (
              <HorizontalStageBox stages={stages} />
            ) : null}
          </Grid>
        )}
      </Grid>

      <CandidateProfilePage isDash={true} />

      <Grid container spacing={3}>
        {/* Notifications */}
        {notifications?.length > 0 && (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box
              sx={{
                border: "1px solid #006CB880",
                borderRadius: "10px",
                minHeight: "200px",
                padding: "20px",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginBottom: "20px",
                  gap: 1, // optional spacing between wrapped items
                }}
              >
                <Typography
                  sx={{
                    px: 2,
                    textAlign: "left",
                    mt: 0.5,
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: "0.5px",
                    fontSize: "30px",
                    color: "#333",
                    fontWeight: 600,
                    flexGrow: 1,
                  }}
                >
                  Notifications
                </Typography>

                <Button
                  variant="text"
                  onClick={() => Navigate(`/Notifications`)}
                  sx={{
                    minWidth: "100px",
                    color: "white",
                    background: "#006CB8",
                    mt: 0.5,
                    height: "30px",
                    textTransform: "capitalize",
                    ml: { xs: "auto", sm: 0 }, // pushes right when wrapped
                  }}
                >
                  View All
                </Button>
              </Box>

              <Box pl={2}>
                {notifications?.length > 0
                  ? notifications.slice(0, 4).map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        top: "5px",
                        minHeight: { sm: "", md: "70px" },
                        // border: "2px solid red",
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent={"flex-start"}
                        alignContent={"flex-start"}
                        spacing={2}
                      >
                        <Box
                          display="flex"
                          alignContent={"flex-start"}
                          gap={1}
                        >
                          <CircleIcon
                            color="info"
                            sx={{
                              width: 15,
                              color: "#006CB8",
                              position: "relative",
                              top: "2px",
                            }}
                          />
                          <Typography
                            sx={{
                              textAlign: "left",
                              fontFamily: "Geist, sans-serif",
                              letterSpacing: `0.5px`,
                              fontSize: "18px",
                              color: "#333",
                              fontWeight: "400",
                            }}
                          >
                            {item.NM_Message}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>
                  ))
                  : ""}
              </Box>
            </Box>
          </Grid>
        )}

        {/* Job Summary */}

        {candidateJobData[0]?.length > 0 &&
          candidateJobData.some((obj) =>
            Object.values(obj).some((value) => value !== null)
          ) && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box
                sx={{
                  border: "1px solid #006CB880",
                  borderRadius: "10px",
                  minHeight: "200px",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: 1, // optional spacing between items
                  }}
                >
                  <Typography
                    sx={{
                      px: 2,
                      textAlign: "left",
                      fontFamily: "Geist, sans-serif",
                      letterSpacing: "0.5px",
                      fontSize: "30px",
                      color: "#333",
                      fontWeight: 600,
                      flexGrow: 1, // take as much space as needed
                    }}
                  >
                    Job Summary
                  </Typography>

                  <Button
                    variant="text"
                    onClick={() => Navigate(`/Summary`)}
                    sx={{
                      minWidth: "100px",
                      color: "white",
                      background: "#006CB8",
                      mt: 0.5,
                      height: "30px",
                      textTransform: "capitalize",
                      ml: { xs: "auto", sm: 0 }, // push to right on wrap
                    }}
                  >
                    View All
                  </Button>
                </Box>

                <Box pl={2}>
                  {candidateJobData[0]?.length
                    ? candidateJobData.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          top: "5px",
                          minHeight: { sm: "", md: "70px" },
                          padding: "6px 0px",
                        }}
                      >
                        {/* Bullet marker */}
                        <Box
                          sx={{
                            position: "absolute",
                            left: 0,
                            top: "10px",
                            width: 12,
                            height: 12,
                            bgcolor: "#006CB8",
                            borderRadius: "50%",
                            zIndex: 1,
                          }}
                        />

                        {/* Content */}
                        <Grid
                          container
                          spacing={1}
                          alignItems="flex-start"
                          sx={{
                            position: "relative",
                            bottom: "5px",
                            pl: "20px",
                            // border: {
                            //   xs: "2px solid yellow",
                            //   sm: "2px solid red",
                            //   md: "2px solid blue",
                            //   lg: "2px solid green",
                            //   xl: "2px solid violet",
                            // },
                          }}
                        >
                          {/* Title + JobId */}
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={8}>
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontFamily: "Geist, sans-serif",
                                letterSpacing: `0.5px`,
                                fontSize: "18px",
                                color: "#333",
                                fontWeight: "600",
                              }}
                            >
                              {item?.JD_Title}
                            </Typography>
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontFamily: "Geist, sans-serif",
                                letterSpacing: `0.5px`,
                                fontSize: "14px",
                                color: "#333",
                                fontWeight: "400",
                              }}
                            >
                              {item?.JD_JobId}
                            </Typography>
                          </Grid>

                          {/* Date + Status */}
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={4}
                            textAlign={{
                              xs: "left",
                              sm: "left",
                              md: "left",
                              lg: "left",
                              xl: "right",
                            }}
                            sx={{ pr: { sm: 2 } }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Geist, sans-serif",
                                letterSpacing: `0.5px`,
                                fontSize: "16px",
                                color: "#333",
                                fontWeight: "600",
                              }}
                            >
                              {item?.JA_AppliedDate}
                            </Typography>
                            <Chip
                              label={item?.JASL_Name}
                              sx={{
                                minWidth: "100px",
                                color: `white`,
                                backgroundColor: `#006CB8`,
                                mt: 0.5,
                              }}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                    : ""}
                </Box>
              </Box>
            </Grid>
          )}
      </Grid>
    </Paper>
  );
};

export default CandidateDash;
